import { createAction, props } from '@ngrx/store';

export const ENROLLMENT_ID = '[Enrollment] EnrollmentId';
export const DASHBOARD_STATE_ID = '[Enrollment] DashboardStateId';
export const BUSINESS_PROFILE_STATE_ID = '[Enrollment] BusinessProfileStateId';
export const FINANCIAL_PROFILE_STATE_ID =
  '[Enrollment] FinancialProfileStateId';
export const ONLY_FINANCIAL_PROFILE_STATE_ID =
  '[Enrollment] OnlyFinancialProfileStateId';
export const CUSTOMER_PORTFOLIO_STATE_ID =
  '[Enrollment] CustomerPortfolioStateId';
export const BUSINESS_PROFILE_STATUS_ID =
  '[Enrollment] BusinessProfileStatusId';
export const FINANCIAL_PROFILE_STATUS_ID =
  '[Enrollment] FinancialProfileStatusId';
export const CUSTOMER_PORTFOLIO_STATUS_ID =
  '[Enrollment] CustomerPortfolioStatusId';
export const APPLICATION_REVIEW_STATUS_ID =
  '[Enrollment] ApplicationReviewStatusId';
export const MSA_SIGNATURE_STATUS_ID = '[Enrollment] MsaSignatureStatusId';
export const NOWACCOUNT_ACTIVATION_STATUS_ID =
  '[Enrollment] NowAccountActivationStatusId';
export const ALL = '[Enrollment] All';
export const ENROLLMENT_STEP_ID = '[Enrollment] EnrollmentStepId';
export const HAS_CLIENT_ADDITIONAL_INFO_REQUEST =
  '[Enrollment] HasClientAdditionalInfoRequest';

export const EnrollmentIdAction = createAction(
  ENROLLMENT_ID,
  props<{
    enrollmentId: string;
  }>()
);

export const DashboardStateIdAction = createAction(
  DASHBOARD_STATE_ID,
  props<{
    dashboardStateId: string;
  }>()
);

export const EnrollmentStepIdAction = createAction(
  ENROLLMENT_STEP_ID,
  props<{
    enrollmentStepId: string;
  }>()
);

export const BusinessProfileStateIdAction = createAction(
  BUSINESS_PROFILE_STATE_ID,
  props<{
    dashboardStateId: string;
    businessProfileStateId: string;
  }>()
);

export const FinancialProfileStateIdAction = createAction(
  FINANCIAL_PROFILE_STATE_ID,
  props<{
    dashboardStateId: string;
    financialProfileStateId: string;
  }>()
);

export const OnlyFinancialProfileStateIdAction = createAction(
  ONLY_FINANCIAL_PROFILE_STATE_ID,
  props<{
    financialProfileStateId: string;
  }>()
);

export const CustomerPortfolioStateIdAction = createAction(
  CUSTOMER_PORTFOLIO_STATE_ID,
  props<{
    dashboardStateId: string;
    customerPortfolioStateId: string;
  }>()
);

export const BusinessProfileStatusIdAction = createAction(
  BUSINESS_PROFILE_STATUS_ID,
  props<{
    businessProfileStatusId: number;
  }>()
);

export const FinancialProfileStatusIdAction = createAction(
  FINANCIAL_PROFILE_STATUS_ID,
  props<{
    financialProfileStatusId: number;
  }>()
);

export const CustomerPortfolioStatusIdAction = createAction(
  CUSTOMER_PORTFOLIO_STATUS_ID,
  props<{
    customerPortfolioStatusId: number;
  }>()
);

export const ApplicationReviewStatusIdAction = createAction(
  APPLICATION_REVIEW_STATUS_ID,
  props<{
    applicationReviewStatusId: number;
  }>()
);

export const MsaSignatureStatusIdAction = createAction(
  MSA_SIGNATURE_STATUS_ID,
  props<{
    msaSignatureStatusId: number;
  }>()
);

export const NowAccountActivationStatusIdAction = createAction(
  NOWACCOUNT_ACTIVATION_STATUS_ID,
  props<{
    nowAccountActivationStatusId: number;
  }>()
);

export const HasClientAdditionalInfoRequestAction = createAction(
  HAS_CLIENT_ADDITIONAL_INFO_REQUEST,
  props<{ hasClientAdditionalInfoRequest: boolean }>()
);

export const AllAction = createAction(
  ALL,
  props<{
    enrollmentId: string;
    enrollmentStepId: number;
    dashboardStateId: number;
    businessProfileStateId: number;
    financialProfileStateId: number;
    customerPortfolioStateId: number;
    businessProfileStatusId: number;
    financialProfileStatusId: number;
    customerPortfolioStatusId: number;
    applicationReviewStatusId: number;
    msaSignatureStatusId: number;
    nowAccountActivationStatusId: number;
    hasClientAdditionalInfoRequest: boolean;
  }>()
);

export type All =
  | ReturnType<typeof EnrollmentIdAction>
  | ReturnType<typeof DashboardStateIdAction>
  | ReturnType<typeof BusinessProfileStateIdAction>
  | ReturnType<typeof FinancialProfileStateIdAction>
  | ReturnType<typeof OnlyFinancialProfileStateIdAction>
  | ReturnType<typeof CustomerPortfolioStateIdAction>
  | ReturnType<typeof BusinessProfileStatusIdAction>
  | ReturnType<typeof FinancialProfileStatusIdAction>
  | ReturnType<typeof CustomerPortfolioStatusIdAction>
  | ReturnType<typeof ApplicationReviewStatusIdAction>
  | ReturnType<typeof MsaSignatureStatusIdAction>
  | ReturnType<typeof NowAccountActivationStatusIdAction>
  | ReturnType<typeof HasClientAdditionalInfoRequestAction>
  | ReturnType<typeof AllAction>;
